jQuery(function($){
    if ($('.fade-in-later').length == 0){
        return;
    }

    $('body').css('margin-bottom', '60px');
    /*
    $(window).on("scroll", function() {
        // Check if the user has scrolled more than 100vh
        if ($(window).scrollTop() > $(window).height() / 2) {
            // Set .socials bottom to 30px
            $(".fade-in-later").css("bottom", "0px");
        } else {
            // Set .socials bottom to -100px when above 100vh
            $(".fade-in-later").css("bottom", "-100px");
        }
        $
    });
    */
});